import { Injectable } from '@angular/core';
// import { AppConfiguration } from '@symphony-solo/shared/app-configuration/src';
// import { HttpService } from '@symphony-solo/shared/http/src';
import { Observable, of } from 'rxjs';

@Injectable()
export class CartService {
  protected path = 'website/chooseLocation';
  constructor(
    // private httpService: HttpService,
    // private appConfig: AppConfiguration
    ) {}

  public getCart(): Observable<any> {
    return of([
      // {
      //   id: 1,
      //   price: '9.15',
      //   quantity: 1,
      //   product: {
      //       id: 1,
      //       name: 'Hamburger',
      //       description: 'Two fresh high-quality beef patties hot off the grill, on a soft, toasted bun.',
      //       price: '9.15',
      //       calaries: '678 kcal',
      //       alergies: 'Gluten, Mustard, Sesame',
      //       suitability: 'Halal',
      //       image: './assets/images/fake_imgs/b1.png',
      //     }
      // }
    ]);
    // return this.httpService.makeGet<void>(this.path,  null, null, {'CompanyGuid': this.appConfig.companyGuid});
  }
}
